import type { FC } from "react";

import {
  FLOATING_CONTAINER_BASE_CLASS,
  FLOATING_CONTAINER_DEFAULTS,
  FLOATING_CONTAINER_SIZE_CLASS_MAP,
  TFloatingContainerProps,
} from "@/ui/components/layout/FloatingContainer";
import { cn } from "@/ui/lib/utils";

export const FloatingContainer: FC<TFloatingContainerProps> = (
  {
    tag: Tag = FLOATING_CONTAINER_DEFAULTS.tag,
    "data-component": component = FLOATING_CONTAINER_DEFAULTS["data-component"],
    size = FLOATING_CONTAINER_DEFAULTS.size,
    className,
    children,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component={component}
    className={cn(
      FLOATING_CONTAINER_BASE_CLASS,
      FLOATING_CONTAINER_SIZE_CLASS_MAP[size],
      className,
    )}
  >
    { children }
  </Tag>
);

FloatingContainer.displayName = "FloatingContainer";
